'use client';
import { PageLayout } from '@xtnd/web/shared/layout';
import { MatterArDetailProvider } from '../components/common';
import { MatterDetailDrawer, InvoiceDetailModal } from '../components/matter-detail';
import { CollectionsQueue } from '../components/collections';

export default function ArCollectionsPage() {
  return (
    <PageLayout
      title="Collections Queue"
      description="Manage your collections data with comprehensive tools."
    >
      <MatterArDetailProvider>
        <CollectionsQueue />
        <MatterDetailDrawer />
        <InvoiceDetailModal />
      </MatterArDetailProvider>
    </PageLayout>
  );
}
